/**
 * 配置常量
 * 移植自 xhshow-go/xhshow/config.go
 */

export const MAX_32BIT = 0xffffffff;
export const MAX_SIGNED_32BIT = 0x7fffffff;
export const MAX_BYTE = 255;

// Base64 字母表
export const STANDARD_BASE64_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
export const CUSTOM_BASE64_ALPHABET =
  'ZmserbBoHQtNP+wOcza/LpngG8yJq42KWYj0DSfdikx3VT16IlUAFM97hECvuRX5';
export const X3_BASE64_ALPHABET =
  'MfgqrsbcyzPQRStuvC7mn501HIJBo2DEFTKdeNOwxWXYZap89+/A4UVLhijkl63G';

// HEX Key 用于 XOR 变换
export const HEX_KEY =
  '71a302257793271ddd273bcee3e4b98d9d7935e1da33f5765e2ea8afb6dc77a51a499d23b67c20660025860cbf13d4540d92497f58686c574e508f46e1956344f39139bf4faf22a3eef120b79258145b2feb5193b6478669961298e79bedca646e1a693a926154a5a7a1bd1cf0dedb742f917a747a1e388b234f2277';

// 序列值范围
export const SEQUENCE_VALUE_MIN = 15;
export const SEQUENCE_VALUE_MAX = 50;

// 窗口属性长度范围
export const WINDOW_PROPS_LENGTH_MIN = 900;
export const WINDOW_PROPS_LENGTH_MAX = 1200;

// 校验和配置
export const CHECKSUM_VERSION = 1;
export const CHECKSUM_XOR_KEY = 115;

// 环境指纹配置
export const ENV_FINGERPRINT_XOR_KEY = 41;
export const ENV_FINGERPRINT_TIME_OFFSET_MIN = 10;
export const ENV_FINGERPRINT_TIME_OFFSET_MAX = 50;

// 前缀
export const X3_PREFIX = 'mns0301_';
export const XYS_PREFIX = 'XYS_';

// Hex 字符集
export const HEX_CHARS = 'abcdef0123456789';

// Xray TraceId 配置
export const XRAY_TRACEID_SEQ_MAX = 8388607;
export const XRAY_TRACEID_TIMESTAMP_SHIFT = 23;
export const XRAY_TRACEID_PART1_LENGTH = 16;
export const XRAY_TRACEID_PART2_LENGTH = 16;
export const B3_TRACEID_LENGTH = 16;

// 版本字节
export const VERSION_BYTES = [119, 104, 96, 41];

// 校验和固定尾部
export const CHECKSUM_FIXED_TAIL = [249, 65, 103, 103, 201, 181, 131, 99, 94, 7, 68, 250, 132, 21];

// 默认签名数据结构
export function newSignatureData(): {
  x0: string;
  x1: string;
  x2: string;
  x3: string;
  x4: string;
} {
  return {
    x0: '4.2.6',
    x1: 'xhs-pc-web',
    x2: 'Windows',
    x3: '',
    x4: '',
  };
}

// B1 密钥
export const B1_SECRET_KEY = 'xhswebmplfbt';

// 公共 User-Agent
export const PUBLIC_USER_AGENT =
  'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36 Edg/142.0.0.0';
